"use strict";

import ReactDOM from 'react-dom';
import React from 'react';

import { _I_, defineSimpleTerm } from 'components/locs';
import { IconGlyphicon } from 'generics/icons';
import { BootButton, CloseButton } from 'generics/buttons';
import { MarketBooks } from 'api/tradeAPICall';

import MoneyUtil from 'components/moneyUtil';
import G_marketConfigStorage from 'components/globalMarketConfigStorage';
import {  ViewItemMarketDepthTotals,  ViewItemMarketDepthTable,  ViewItemMarketDepthOwnWarning  } from 'components/itemMarketDepth';
import {  BriefBookLoader  } from 'components/briefBookLoader';
import ViewOrdersGraph from 'components/ordersGraph';
import ViewPriceHistoryGraph from 'components/priceHistoryGraph';
import spawnConfirmSellModal from 'components/confirmSellDialog';
import spawnConfirmDialogModal  from 'components/confirmBuyDialog';
import ViewTradeTickerLog from 'components/tradeTickerLog';
import {  LimitedAccountPanel  } from 'components/credentialsIcon';
import {  isExpired, isCountryDenied  } from 'components/classInfoUtil';
import {  isPairBlocked  } from 'api/rpcAPICall';


LogStream.enable("VIEWITEMMARKETDETAILSCONTROLLER");


function limitedAccountMessage(creds)  {
  const {  need2step,  have2step,  needEmailVerification,  haveEmailVerification  } = creds;
  const twoStep = (need2step && (!have2step) &&
                    _I_("limitedAccountMessage.2step"));
  const verified = (needEmailVerification && (!haveEmailVerification) &&
                     _I_("limitedAccountMessage.verifiedEmail"));

  if ( twoStep || verified )  {
    const combined = [twoStep, verified].filter(Boolean).join(_I_("limitedAccountMessage.and"));
    return `${_I_("limitedAccountMessage.requires")} ${combined}`;
  }
}


export default class ViewItemMarketDetailsController extends React.Component  {
  constructor(props)  {
    super(props);

    const creds  =  SettingsInjections.getCredentials() || {};
    const limitedAccount = limitedAccountMessage(creds);

    this.state =  {
        creds, limitedAccount,
        haveOwnSellOrders:false,
        haveOwnBuyOrders:false,
        totalSellDepth:0,
        totalBuyDepth:0,
        ordersSell:[],
        ordersBuy:[],
      };

    this.onUpdateBriefBook = (resp)  =>  this.updateBriefBook(resp);
  }


  getInitialPrices()  {
    const startBuyPrice  = (this.state.ordersBuy  || [])[0];
    const startSellPrice = (this.state.ordersSell || [])[0];

    const initialSellPrice = (startBuyPrice  || startSellPrice || {}).price;
    const initialBuyPrice  = (startSellPrice || startBuyPrice  || {}).price;

    return  {  initialSellPrice,  initialBuyPrice  };
  }


  canTrade()  {
    if (this.state.limitedAccount)
      return  false;

    const {  classInfo,  blockedAfter  } = this.props;

    if ( isExpired(classInfo) )
      return  false;

    if ( isPairBlocked(blockedAfter) )
      return  false;

    return true;
  }


  clickSell()  {
    if ( !this.props.haveItems )
      return;

    if ( !this.canTrade() )
      return;

    const {  initialSellPrice  } = this.getInitialPrices();

    const {  classInfo,  market_name,  asssid,  ctxid, appid, totalAmount, instances  } = this.props;
    const haveOwnOrders = this.state.haveOwnBuyOrders;

    spawnConfirmSellModal(  appid,  ctxid,  asssid,  market_name,  classInfo,
                            initialSellPrice,  haveOwnOrders, totalAmount, instances );
  }


  clickBuy()  {
    if ( !this.canTrade() )
      return;

    const {  classInfo,  market_name,  appid  } = this.props;
    const haveOwnOrders = this.state.haveOwnSellOrders;
    const countryDenied = isCountryDenied(classInfo);

    if ( countryDenied )
      return;

    const {  initialBuyPrice  } = this.getInitialPrices();

    spawnConfirmDialogModal(  initialBuyPrice,  appid,  market_name,  classInfo, haveOwnOrders );
  }


  updateBriefBook(resp)  {
    this.setState( resp );
  }


  render()  {
    const bookLengthLimit = 5;

    const  {
        totalSellDepth,  totalBuyDepth,  ordersSell,  ordersBuy,
        haveOwnSellOrders,  haveOwnBuyOrders, limitedAccount,
      } = this.state;
    const {  classInfo,  blockedAfter  } = this.props;
    const blockedItem = isPairBlocked(blockedAfter);
    const expiredItem = isExpired(classInfo);
    const countryDenied = isCountryDenied(classInfo);
    return (
          <div>
            <LimitedAccountPanel creds={this.state.creds} />

            {!expiredItem &&
              <div className="view-market-details-two-columns">
                <ViewItemMarketDepthTotals type="buy"
                                           total={totalBuyDepth}
                                           orders={ordersBuy} />

                <ViewItemMarketDepthTotals type="sell"
                                           total={totalSellDepth}
                                           orders={ordersSell} />
              </div>
            }

            {!expiredItem &&
              <div className="view-market-details-two-columns">
                <ViewItemMarketDepthTable type="buy"
                                          orders={ordersBuy}
                                          total={totalBuyDepth}
                                          lines={bookLengthLimit}  />

                <ViewItemMarketDepthTable type="sell"
                                          orders={ordersSell}
                                          total={totalSellDepth}
                                          lines={bookLengthLimit}  />
              </div>
            }

            {!expiredItem &&
              <div className="view-market-details-two-columns">
                <ViewItemMarketDepthOwnWarning  type="buy"  haveOwnOrders={haveOwnBuyOrders}  />
                <ViewItemMarketDepthOwnWarning  type="sell"  haveOwnOrders={haveOwnSellOrders}  />
              </div>
            }

            {(!expiredItem && !blockedItem) &&
              <div className="view-market-details-two-columns">
                <BootButton block  disabled={ limitedAccount || !this.props.haveItems }
                            variant={this.props.haveItems ? "success" : "default"}
                            title={limitedAccount}
                            onClick={()=>this.clickSell()}
                       >
                  {_I_(this.props.haveItems ?
                          "ItemMarketDetails.sellButton" :
                          "ItemMarketDetails.nothingToSellButton")}
                </BootButton>

                <BootButton variant={"success"}  block
                            disabled={limitedAccount || countryDenied}
                            title={limitedAccount}
                            onClick={()=>this.clickBuy()}
                        >{_I_("ItemMarketDetails.buyButton")}</BootButton>
              </div>
            }

            <ViewTradeTickerLog limitTickerLog={4}
                                market_name={this.props.market_name}
                                appid={this.props.appid}
                              />

            <ViewOrdersGraph sellOrders={ordersSell /*grouped*/}
                             buyOrders={ordersBuy /*grouped*/}
                             totalSell={totalSellDepth}
                             totalBuy={totalBuyDepth} />

            <ViewPriceHistoryGraph
                  market_name={this.props.market_name}
                  appid={this.props.appid}
                />

            <BriefBookLoader  onUpdate={this.onUpdateBriefBook}
                              market_name={this.props.market_name}
                              appid={this.props.appid}
                            />

          </div>
    );
  }

}


defineSimpleTerm( "ItemMarketDetails.buyButton",  "BUY",       {
  "ru_RU": "Купить",
  "cs_CZ": "KOUPIT",
  "fr_FR": "ACHETER",
  "de_DE": "KAUFEN",
  "it_IT": "COMPRA",
  "ko_KR": "구매",
  "pl_PL": "KUP",
  "pt_PT": "BUY",
  "es_ES": "COMPRAR",
  "zh_CN": "购买",
  "zh_TW": "購 買 "
} );


defineSimpleTerm( "ItemMarketDetails.sellButton",  "SELL",       {
  "ru_RU": "Продать",
  "cs_CZ": "PRODAT",
  "fr_FR": "VENDRE",
  "de_DE": "VERKAUFEN",
  "it_IT": "VENDI",
  "ko_KR": "판매",
  "pl_PL": "SPRZEDAJ",
  "pt_PT": "SELL",
  "es_ES": "VENDER",
  "zh_CN": "出售",
  "zh_TW": "出 售 "
} );


defineSimpleTerm( "ItemMarketDetails.nothingToSellButton",  "Nothing to sell",       {
  "ru_RU": "Нет предметов",
  "cs_CZ": "Nic k prodeji",
  "fr_FR": "Rien à vendre",
  "de_DE": "Nichts zu verkaufen",
  "it_IT": "Niente da vendere",
  "ko_KR": "판매할 물품이 없습니다",
  "pl_PL": "Brak przedmiotów do sprzedania",
  "pt_PT": "Nothing to sell",
  "es_ES": "Nada que vender",
  "zh_CN": "没有要出售的物品",
  "zh_TW": "沒有要出售的物 品 "
} );


defineSimpleTerm( "limitedAccountMessage.requires",  "Requires:",       {
  "ru_RU": "Необходимо:",
  "cs_CZ": "Vyžaduje:",
  "fr_FR": "Requis:",
  "de_DE": "Erfordert:",
  "it_IT": "Richiede:",
  "ko_KR": "요구함:",
  "pl_PL": "Wymaga:",
  "pt_PT": "Requires:",
  "es_ES": "Requiere:",
  "zh_CN": "需要：",
  "zh_TW": "需 要 "
} );


defineSimpleTerm( "limitedAccountMessage.2step",  "two-step protection",       {
  "ru_RU": "двухэтапная авторизация",
  "cs_CZ": "dvoufázové ověření",
  "fr_FR": "protection en deux étapes",
  "de_DE": "Absicherung in zwei Schritten",
  "it_IT": "protezione in due fasi",
  "ko_KR": "이중 보안",
  "pl_PL": "dwuetapowa ochrona",
  "pt_PT": "two-step protection",
  "es_ES": "protección de dos pasos",
  "zh_CN": "两步防护",
  "zh_TW": "兩步防 護 "
} );


defineSimpleTerm( "limitedAccountMessage.verifiedEmail",  "verified email",       {
  "ru_RU": "провереный email",
  "cs_CZ": "potvrzený e-mail",
  "fr_FR": "email vérifié",
  "de_DE": "verifizierte Email",
  "it_IT": "email verificata",
  "ko_KR": "이메일 본인 확인",
  "pl_PL": "potwierdzony email",
  "pt_PT": "verified email",
  "es_ES": "correo electrónico verificado",
  "zh_CN": "电子邮件已验证",
  "zh_TW": "電子信箱已驗 證 "
} );


defineSimpleTerm( "limitedAccountMessage.and",  " and ",       {
  "ru_RU": " и ",
  "cs_CZ": " a ",
  "fr_FR": " et ",
  "de_DE": " und ",
  "it_IT": " e ",
  "ko_KR": " 그리고 ",
  "pl_PL": " i ",
  "pt_PT": " and ",
  "es_ES": " y ",
  "zh_CN": " 与 ",
  "zh_TW": " 與 "
} );

